export const Languages = [
  { value: 'en', label: 'English' },
  { value: 'ar', label: 'Arabic' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'zh', label: 'Chinese (Simplified)' },
  { value: 'hi', label: 'Hindi' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'ru', label: 'Russian' },
  { value: 'ja', label: 'Japanese' },
  { value: 'ko', label: 'Korean' },
  { value: 'it', label: 'Italian' },
  { value: 'nl', label: 'Dutch' },
  { value: 'sv', label: 'Swedish' },
  { value: 'fi', label: 'Finnish' },
  { value: 'no', label: 'Norwegian' },
  { value: 'pl', label: 'Polish' },
  { value: 'tr', label: 'Turkish' },
  { value: 'he', label: 'Hebrew' },
  { value: 'id', label: 'Indonesian' },
  { value: 'ms', label: 'Malay' },
  { value: 'th', label: 'Thai' },
  { value: 'vi', label: 'Vietnamese' },
  { value: 'el', label: 'Greek' },
  { value: 'hu', label: 'Hungarian' },
  { value: 'uk', label: 'Ukrainian' },
  { value: 'ro', label: 'Romanian' },
  { value: 'hr', label: 'Croatian' },
  { value: 'sk', label: 'Slovak' },
  { value: 'sl', label: 'Slovenian' },
  { value: 'lt', label: 'Lithuanian' },
  { value: 'lv', label: 'Latvian' },
  { value: 'kn', label: 'Kannada' },
  { value: 'ml', label: 'Malayalam' },
  { value: 'mr', label: 'Marathi' },
  { value: 'ta', label: 'Tamil' },
  { value: 'te', label: 'Telugu' },
  //   { value: 'es', label: 'Spanish' },
  //   { value: 'fr', label: 'French' },
  //   { value: 'de', label: 'German' },
  //   { value: 'zh', label: 'Chinese (Simplified)' },
  //   { value: 'zh-TW', label: 'Chinese (Traditional)' },
  //   { value: 'hi', label: 'Hindi' },
  //   { value: 'pt', label: 'Portuguese' },
  //   { value: 'ru', label: 'Russian' },
  //   { value: 'ja', label: 'Japanese' },
  //   { value: 'ko', label: 'Korean' },
  //   { value: 'it', label: 'Italian' },
  //   { value: 'nl', label: 'Dutch' },
  //   { value: 'sv', label: 'Swedish' },
  //   { value: 'fi', label: 'Finnish' },
  //   { value: 'no', label: 'Norwegian' },
  //   { value: 'pl', label: 'Polish' },
  //   { value: 'tr', label: 'Turkish' },
  //   { value: 'he', label: 'Hebrew' },
  //   { value: 'id', label: 'Indonesian' },
  //   { value: 'ms', label: 'Malay' },
  //   { value: 'th', label: 'Thai' },
  //   { value: 'vi', label: 'Vietnamese' },
  //   { value: 'el', label: 'Greek' },
  //   { value: 'hu', label: 'Hungarian' },
  //   { value: 'uk', label: 'Ukrainian' },
  //   { value: 'ro', label: 'Romanian' },
  //   { value: 'bg', label: 'Bulgarian' },
  //   { value: 'hr', label: 'Croatian' },
  //   { value: 'sr', label: 'Serbian' },
  //   { value: 'sk', label: 'Slovak' },
  //   { value: 'sl', label: 'Slovenian' },
  //   { value: 'lt', label: 'Lithuanian' },
  //   { value: 'lv', label: 'Latvian' },
  //   { value: 'et', label: 'Estonian' },
  //   { value: 'fa', label: 'Persian' },
  //   { value: 'bn', label: 'Bengali' },
  //   { value: 'pa', label: 'Punjabi' },
  //   { value: 'gu', label: 'Gujarati' },
  //   { value: 'ta', label: 'Tamil' },
  //   { value: 'te', label: 'Telugu' },
  //   { value: 'kn', label: 'Kannada' },
  //   { value: 'ml', label: 'Malayalam' },
  //   { value: 'mr', label: 'Marathi' },
  //   { value: 'sw', label: 'Swahili' },
  //   { value: 'yo', label: 'Yoruba' },
  //   { value: 'ha', label: 'Hausa' },
  //   { value: 'am', label: 'Amharic' },
  //   { value: 'ur', label: 'Urdu' },
  //   { value: 'si', label: 'Sinhala' },
  //   { value: 'mn', label: 'Mongolian' },
  //   { value: 'my', label: 'Burmese' },
  //   { value: 'km', label: 'Khmer' },
  //   { value: 'lo', label: 'Lao' },
  //   { value: 'ne', label: 'Nepali' },
  //   { value: 'ps', label: 'Pashto' },
  //   { value: 'kk', label: 'Kazakh' },
  //   { value: 'uz', label: 'Uzbek' },
  //   { value: 'tg', label: 'Tajik' },
  //   { value: 'tk', label: 'Turkmen' },
  //   { value: 'bo', label: 'Tibetan' },
];
